export namespace VikingMaltCalculator {
    export interface IConstantProps {
        variety?: string | undefined;
        cropYear?: string | undefined;
    }

    export interface IParameterProperties {
        id: string;
        sp: number | null;
        min: number | null;
        max: number | null;
    }
}